<script lang="ts" module>
  import type { SVGAttributes } from 'svelte/elements';

  export interface LogoAllCapsShortProps extends SVGAttributes<SVGSVGElement> {
    /**
     * scale factor
     * @default 1 equals 109px x 48px
     */
    scale?: number;
    title?: string;
    textColor?: string;
    starsColor?: string;
  }
</script>

<script lang="ts">
  let {
    scale = 1,
    starsColor = '#4F4F4F',
    textColor = '#66BD0A',
    title = 'teo | SUITE',
    class: className,

    ...rest
  }: LogoAllCapsShortProps = $props();
</script>

<svg
  width={scale * 109}
  height={scale * 48}
  viewBox="0 0 109 48"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  class={className}
  {...rest}
>
  {#if title}<title>{title}</title>{/if}

  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M74.4595 47.8348C71.9995 47.8348 69.7345 47.4148 67.6645 46.5748C65.5945 45.7348 63.7795 44.5648 62.2195 43.0648C60.6895 41.5648 59.4895 39.8098 58.6195 37.7998C57.7495 35.7598 57.3145 33.5698 57.3145 31.2298C57.3145 28.8898 57.7345 26.7298 58.5745 24.7498C59.4445 22.7398 60.6445 20.9848 62.1745 19.4848C63.7045 17.9848 65.5044 16.8298 67.5744 16.0198C69.6445 15.1798 71.9095 14.7598 74.3695 14.7598C76.8295 14.7598 79.0945 15.1798 81.1645 16.0198C83.2345 16.8298 85.0345 17.9848 86.5645 19.4848C88.0945 20.9848 89.2795 22.7398 90.1195 24.7498C90.9895 26.7598 91.4245 28.9348 91.4245 31.2748C91.4245 33.6148 90.9895 35.7898 90.1195 37.7998C89.2795 39.8098 88.0945 41.5798 86.5645 43.1098C85.0345 44.6098 83.2345 45.7798 81.1645 46.6198C79.1245 47.4298 76.8895 47.8348 74.4595 47.8348ZM74.3695 40.6348C76.1695 40.6348 77.7295 40.2448 79.0495 39.4648C80.3695 38.6848 81.3895 37.5898 82.1095 36.1798C82.8295 34.7698 83.1895 33.1198 83.1895 31.2298C83.1895 29.8498 82.9795 28.5898 82.5594 27.4498C82.1694 26.3098 81.5845 25.3348 80.8045 24.5248C80.0245 23.6848 79.0945 23.0398 78.0145 22.5898C76.9345 22.1398 75.7195 21.9148 74.3695 21.9148C72.5695 21.9148 71.0095 22.3048 69.6895 23.0848C68.3695 23.8348 67.3494 24.9148 66.6295 26.3248C65.9095 27.7348 65.5495 29.3698 65.5495 31.2298C65.5495 32.6698 65.7445 33.9748 66.1345 35.1448C66.5545 36.2848 67.1544 37.2748 67.9344 38.1148C68.7145 38.9248 69.6445 39.5548 70.7245 40.0048C71.8045 40.4248 73.0195 40.6348 74.3695 40.6348ZM31.248 47.2497V15.3447H37.6381H39.303H54.648V22.1397H39.303V27.6747H53.298V34.2897H39.303V40.4547H54.918V47.2497H39.303H37.6381H31.248ZM9.765 22.2747V47.2497H17.82V22.2747H27.585V15.3447H0V22.2747H9.765Z"
    fill={textColor}
  />
  <path
    d="M94.8889 4.22222L92.1111 10.3333L86 13.1111L92.1111 15.8889L94.8889 22L97.6667 15.8889L103.778 13.1111L97.6667 10.3333L94.8889 4.22222ZM103.778 2L102.389 5.05556L99.3333 6.44444L102.389 7.83333L103.778 10.8889L105.167 7.83333L108.222 6.44444L105.167 5.05556L103.778 2Z"
    fill={starsColor}
  />
</svg>
